import { includes } from 'lodash';

export default {
  read: () => {
    const key = Object.keys(localStorage).filter(k => includes(k, 'login.windows.net-accesstoken'))[0];
    const accessToken = localStorage.getItem(key);
    return accessToken ? JSON.parse(accessToken).secret : '';
  },
};
